import React from "react";
import HeathrowLiveStatusCompact from "./HeathrowLiveStatusCompact";

const CcgRouteLhrStatusCompact = ({
  title = "Live Heathrow checks for this route",
  kicker = "Live Heathrow intelligence",
  className = "",
  statusProfile = "",
}) => (
  <HeathrowLiveStatusCompact
    title={title}
    kicker={kicker}
    className={`ccg-route-lhr ${className}`.trim()}
    statusProfile={statusProfile}
  />
);

export default CcgRouteLhrStatusCompact;
